/* src/app/admin-dashboard/kunde-kort/kunde-kort.component.css */
:host {
  --kl-ink: #0f172a;
  --kl-text: #334155;
  --kl-muted: #64748b;
  --kl-faint: #94a3b8;
  --kl-line: #e2e8f0;
  --kl-bg: #f8fafc;
  --kl-accent: var(--custom-color, #0369a1);
  display: block;
  color: var(--kl-text);
  font-size: 13.5px;
}
.kl-page {
  padding: 4px 0 24px;
}
.kl-head {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 14px;
}
.kl-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: var(--kl-ink);
}
.kl-spacer {
  flex: 1 1 auto;
}
.kl-head .mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  vertical-align: middle;
  margin-right: 2px;
}
.kl-view-toggle ::ng-deep .mat-button-toggle-label-content {
  line-height: 34px;
  font-size: 13px;
  padding: 0 12px;
}
.kl-stats {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 14px;
}
.kl-stat {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  padding: 10px 14px;
  border: 1px solid var(--kl-line);
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  text-align: left;
  transition: border-color .15s, box-shadow .15s;
}
.kl-stat:hover {
  border-color: #cbd5e1;
}
.kl-stat:focus-visible {
  outline: 2px solid var(--kl-accent);
  outline-offset: 2px;
}
.kl-stat.active {
  border-color: var(--kl-accent);
  box-shadow: inset 0 0 0 1px var(--kl-accent);
}
.kl-stat-value {
  font-size: 20px;
  font-weight: 600;
  color: var(--kl-ink);
  font-variant-numeric: tabular-nums;
  line-height: 1.3;
}
.kl-stat-label {
  font-size: 12px;
  color: var(--kl-muted);
}
.kl-stat--warn .kl-stat-value {
  color: #b45309;
}
.kl-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.kl-search {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1 1 320px;
  max-width: 460px;
  padding: 0 8px;
  height: 34px;
  border: 1px solid var(--kl-line);
  border-radius: 8px;
  background: #fff;
}
.kl-search:focus-within {
  border-color: var(--kl-accent);
}
.kl-search > .mat-icon {
  color: var(--kl-faint);
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.kl-search input {
  flex: 1 1 auto;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  font-size: 13.5px;
  color: var(--kl-ink);
}
.kl-search-clear {
  border: 0;
  background: none;
  padding: 0;
  display: flex;
  color: var(--kl-faint);
  cursor: pointer;
}
.kl-search-clear .mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.kl-select {
  width: auto;
  min-width: 160px;
  height: 34px;
}
.kl-count {
  font-size: 12.5px;
  color: var(--kl-muted);
}
.kl-table-wrap {
  border: 1px solid var(--kl-line);
  border-radius: 10px;
  overflow: auto;
  background: #fff;
  max-height: calc(100vh - 290px);
}
.kl-table {
  width: 100%;
}
.kl-table th.mat-mdc-header-cell {
  background: var(--kl-bg);
  color: var(--kl-muted);
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  white-space: nowrap;
  padding: 0 10px;
  height: 38px;
}
.kl-table td.mat-mdc-cell {
  padding: 8px 10px;
  border-bottom-color: #f1f5f9;
  vertical-align: middle;
  font-size: 13.5px;
}
.kl-table th.num,
.kl-table td.num {
  text-align: right;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.kl-table th.num ::ng-deep .mat-sort-header-container {
  justify-content: flex-end;
}
.kl-row {
  cursor: pointer;
}
.kl-row:hover td {
  background: var(--kl-bg);
}
.kl-row:focus-visible {
  outline: 2px solid var(--kl-accent);
  outline-offset: -2px;
}
.kl-empty {
  padding: 32px 16px;
  text-align: center;
  color: var(--kl-faint);
}
.kl-customer {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 220px;
}
.kl-avatar {
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: color-mix(in srgb, var(--kl-accent) 12%, white);
  color: var(--kl-accent);
  font-size: 12px;
  font-weight: 700;
}
.kl-customer-main {
  min-width: 0;
}
.kl-name {
  font-weight: 600;
  color: var(--kl-ink);
}
.kl-sub {
  display: flex;
  flex-wrap: wrap;
  gap: 0 10px;
  font-size: 12px;
  color: var(--kl-muted);
}
.kl-muted {
  color: var(--kl-faint);
}
.kl-mono {
  font-family:
    ui-monospace,
    SFMono-Regular,
    Menlo,
    monospace;
  font-size: 12.5px;
}
.kl-pill {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 999px;
  font-size: 11.5px;
  font-weight: 600;
  line-height: 1.6;
  white-space: nowrap;
  background: #f1f5f9;
  color: #475569;
}
.kl-pill--warn {
  background: #fef3c7;
  color: #92400e;
}
.kl-pill--risk {
  background: #fee2e2;
  color: #b91c1c;
}
.kl-cat--lead {
  background: #f1f5f9;
  color: #475569;
}
.kl-cat--prospect {
  background: #fef3c7;
  color: #92400e;
}
.kl-cat--active {
  background: #dcfce7;
  color: #166534;
}
.kl-cat--inactive {
  background: #f1f5f9;
  color: var(--kl-faint);
}
.kl-systems-cell {
  max-width: 340px;
}
.kl-systems {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.kl-sys {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 1px 7px;
  border-radius: 6px;
  font-size: 12px;
  background: #eef2ff;
  color: #3730a3;
}
.kl-sys--off {
  background: #f1f5f9;
  color: var(--kl-faint);
  text-decoration: line-through;
}
.kl-sys--more {
  background: transparent;
  color: var(--kl-muted);
  font-weight: 600;
}
.kl-actions {
  width: 1%;
  white-space: nowrap;
  text-align: right;
}
.kl-actions .mat-mdc-icon-button {
  color: var(--kl-faint);
  opacity: 0;
  transition: opacity .15s;
}
.kl-row:hover .kl-actions .mat-mdc-icon-button,
.kl-row:focus-within .kl-actions .mat-mdc-icon-button {
  opacity: 1;
}
.kl-chevron {
  color: #cbd5e1;
  vertical-align: middle;
}
.kl-tree-toggle {
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
  margin-right: -4px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 6px;
  background: none;
  color: var(--kl-muted);
  cursor: pointer;
}
.kl-tree-toggle:hover {
  background: #e2e8f0;
}
.kl-tree-toggle:focus-visible {
  outline: 2px solid var(--kl-accent);
}
.kl-tree-spacer {
  flex: 0 0 20px;
}
.kl-customer--unit {
  padding-left: 22px;
}
.kl-unit-icon {
  flex: 0 0 auto;
  color: #cbd5e1;
  font-size: 18px;
  width: 18px;
  height: 18px;
  margin-right: -4px;
}
.kl-row--unit td {
  background: #fbfcfe;
}
.kl-row--unit .kl-avatar {
  width: 26px;
  height: 26px;
  font-size: 11px;
}
.kl-dimmed .kl-name {
  color: var(--kl-muted);
}
.kl-pill--org {
  margin-left: 6px;
  background: #e0f2fe;
  color: #075985;
  font-size: 11px;
  vertical-align: 1px;
}
.kl-part-of {
  color: #0369a1;
}
.kl-incl,
.kl-sub--end {
  justify-content: flex-end;
  font-size: 11px;
}
@media (max-width: 1100px) {
  .kl-stats {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 640px) {
  .kl-stats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .kl-search {
    max-width: none;
  }
}
@media (hover: none) {
  .kl-actions .mat-mdc-icon-button {
    opacity: 1;
  }
}
@media (prefers-reduced-motion: reduce) {
  .kl-stat,
  .kl-actions .mat-mdc-icon-button {
    transition: none;
  }
}
/*# sourceMappingURL=kunde-kort.component.css.map */
